import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useHistory } from "react-router";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import TenantService from "api/tenant.service";
import AssetsService from "api/assets.service";
import FeaturesService from "api/features.service";
import { LoadPanel as LoadingPanel } from 'devextreme-react/load-panel';
import Toast from 'components/Toast';
import moment from 'moment-timezone';
import { SelectBox } from 'devextreme-react';
import { DateBox } from 'devextreme-react/date-box';
import './assetTab.css'
import AssetViewMultiple from "./assetMultiple"
import UtilizationHeatMap from "./mechnicalAttributes/utilizationHeatMap";
import CheckBox from 'devextreme-react/check-box';
import {
    EditTab,
    ActionsTab,
    // DropDownTemperature,
    // TemperatureChart,
    CyclesChart,
} from './mechnicalAttributes';

export default function App(props) {
    const tabPanelRef = useRef(null);
    const assetMultipleRef = useRef(null);
    console.log("props",props)
    const ids = useMemo(() => {
        return props.location.state?.id ?? [];
    }, [props.location.state?.id]);
    console.log("ids",ids)
    const names = useMemo(() => {
        return props.location.state?.name ?? [];
    }, [props.location.state?.name]); // Only re-calculate if the specific property changes
    const tenant = TenantService.getTenant();
    // const [isUtilizationVisible, setIsUtilizationVisible] = useState(false);
    // const [isTelemetryVisible, setIsTelemetryVisible] = useState(false);
    // const [isActionsVisible, setIsActionsVisible] = useState(false);
    const [checkAutoUpdate, setCheckAutoUpdate] = useState(false);
    const intervalRef = useRef(null);
    const WAIT_TIME = 10000;
    const storageKey = `${tenant}-util-filter`;
    const [palette, setPalette] = useState([]);
    // const assetId = ids[0]
    const [startDate, setStartDate] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.startDate ? filters.startDate : null;
        }
        return moment().subtract(24, 'hours').format();; // Default if nothing exists
    });
    const [endDate, setEndDate] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.endDate ? filters.endDate : null;
        }
        return moment().format();; // Default if nothing exists
    });
    const [selectedPeriod, setSelectedPeriod] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            const filters = JSON.parse(saved);
            return filters.selectedPeriod ? filters.selectedPeriod : 'Last 24 hours';
        } else {
            return 'Last 24 hours'
        }
    });
    const [selectedSpace2, setSelectedSpace2] = useState()
    const [types, setTypes] = useState([]);
    const [pageName, setPageName] = useState("");
    const [editAllowed, setEditAllowed] = useState(false);
    const [popupVisible, setPopupVisible] = useState(false);
    const [editedFlag, setEditedFlag] = useState(false);
    const [lastPositionUpdateTime, setLastPositionUpdateTime] = useState("");
    const [latestDwellTime, setLatestDwellTime] = useState("");
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [floorplanGeo, setFloorplanGeo] = useState(false)
    const [filters, setFilters] = useState([]);
    const [spaces, setSpaces] = useState([]);

    // const [checkInOut, setCheckInOut] = useState({ isfeature: false, isDeviceFeature: false });
    // const [retrieval, setretrieval] = useState({ isfeature: false, isDeviceFeature: false });
    // const [utilization, setUtilization] = useState({ isfeature: false, isDeviceFeature: false });
    // const [temperatureTelemetry, setTemperatureTelemetry] = useState({ isfeature: false, isDeviceFeature: false });
    // const [cycleTelemetry, setCycleTelemetry] = useState({ isfeature: false, isDeviceFeature: false });
    // const [maintenance, setMaintenance] = useState({ isfeature: false, isDeviceFeature: false });
    // const [impactTelemetry, setImpactTelemetry] = useState({ isfeature: false, isDeviceFeature: false });

    const [features, setFeatures] = useState({
        checkInOut: { isfeature: false, isDeviceFeature: false },
        retrieval: { isfeature: false, isDeviceFeature: false },
        utilization: { isfeature: false, isDeviceFeature: false },
        temperatureTelemetry: { isfeature: false, isDeviceFeature: false },
        cycleTelemetry: { isfeature: false, isDeviceFeature: false },
        maintenance: { isfeature: false, isDeviceFeature: false },
        impactTelemetry: { isfeature: false, isDeviceFeature: false },
    });

    const [loading, setLoading] = useState(false);
    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });
    const history = useHistory();
    if (ids.length === 0) {
        goBack()
    }

    useEffect(() => {
        // Map the ID to the KEY in your state object
        const featureKeys = [
            "checkInOut", "retrieval", "utilization", 
            "temperatureTelemetry", "cycleTelemetry", 
            "maintenance", "impactTelemetry"
        ];
    
        const formatState = (val) => {
            const isBool = typeof val === 'boolean';
            return { isfeature: isBool, isDeviceFeature: isBool ? val : false };
        };
    
        const fetchPromises = featureKeys.map((_, index) => 
            FeaturesService.getTenantFeature(tenant, index)
        );
    
        Promise.all(fetchPromises)
            .then((results) => {
                const newState = {};
                results.forEach((result, index) => {
                    const key = featureKeys[index];
                    newState[key] = formatState(result.data.data);
                });
                
                // One single render update for all 7 features!
                setFeatures(newState);
            })
            .catch(err => console.error(err));
    }, [tenant]);

    const assetColorMap = useMemo(() => {
        if (palette.length === 0 || ids.length === 0) return {};
        const map = {};
        ids.forEach((id, index) => {
            const colorData = palette[index % palette.length];
            const color = colorData ? `rgb(${colorData[0]}, ${colorData[1]}, ${colorData[2]})` : 'rgb(0,0,0)';
            // Key by both UUID and name so any child can look up by either
            map[id] = color;
            if (names[index]) map[names[index]] = color;
        });
        return map;
    }, [ids, names, palette]);

    useEffect(() => {
        fetch('/colors.json')
          .then(res => res.json())
          .then(data => setPalette(data));
      }, []);

    // useEffect(() => {
    //     // Only fetch once when the component mounts
    //     FeaturesService.getTenantModule(tenant, 0)
    //         .then((result) => {
    //             let isModuleFeature = result.data.data
    //             if (isModuleFeature) {
    //                 setIsActionsVisible(true);
    //             }
    //             // setIsLoading(false);
    //         })
    //         .catch((err) => {
    //             console.error("Failed to fetch module access", err);
    //             // setIsLoading(false);
    //         });
    //     FeaturesService.getTenantFeature(tenant, 2)
    //         .then((result) => {
    //             let isDeviceFeature = result.data.data
    //             if (isDeviceFeature === false) {
    //                 setIsUtilizationVisible(true);
    //             }
    //             // setIsLoading(false);
    //         })
    //         .catch((err) => {
    //             console.error("Failed to fetch module access", err);
    //             // setIsLoading(false);
    //         });
    //     FeaturesService.getTenantFeature(tenant, 3)
    //         .then((result) => {
    //             let isDeviceFeature = result.data.data
    //             if (isDeviceFeature === true) {
    //                 FeaturesService.getTenantFeature(tenant, 4)
    //                     .then((result) => {
    //                         let isDeviceFeature2 = result.data.data
    //                         if (isDeviceFeature2 === false) {
    //                             setIsUtilizationVisible(true);
    //                         }
    //                         // setIsLoading(false);
    //                     })
    //                     .catch((err) => {
    //                         console.error("Failed to fetch module access", err);
    //                         // setIsLoading(false);
    //                     });
    //             } else if (isDeviceFeature === false) {
    //                 setIsTelemetryVisible(true);
    //             } else { //isDeviceFeature = null
    //                 setIsTelemetryVisible(false);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Failed to fetch module access", err);
    //             // setIsLoading(false);
    //         });
    // }, [tenant]); // Only re-run if the tenant changes

    function checkRole() {
        var role = JSON.parse(localStorage.getItem("role"));
        let canEdit = false
        for (let i = 0; i < role.length; i++) {
            if (role[i].name === "Asset Attributes") {
                if (role[i].write === true) {
                    canEdit = true
                }
            }
        }
        if (canEdit) {
            setEditAllowed(true)
        }
    }

    function getTypes() {
        AssetsService.getAssetTenantTypes(tenant).then((value) => {
            let response = value.data
            setTypes(response.data)
        })
    }

    function goBack() {
        history.push({
            pathname: `/assets/`,
            state: {
                response: ""
            }
        })
    }

    useEffect(() => {
        getTypes()
        checkRole()
    }, []);

    useEffect(() => {
    }, [types]);

    function onSave() {
        if (editedFlag) {
            setPopupVisible(true)
        } else {
            goBack()
        }
    }

    // const handleStartDateChange = async (value) => {
    //     console.log("handleStartDateChange")
    //     setStartDate(value);
    //     setSelectedPeriod('Custom');
    // };

    // const handleEndDateChange = async (value) => {
    //     setEndDate(value);
    //     setSelectedPeriod('Custom');
    // };

    const handleStartDateChange = async (value) => {
        const now = moment();
        // Cap start to now — never allow a future start
        const clampedStart = moment(value).isAfter(now) ? now.format() : value;

        // If clamped start is after current end, bring end up to match (already ≤ now)
        const newEnd = moment(clampedStart).isAfter(moment(endDate)) ? clampedStart : endDate;

        const newPeriod = 'Custom';
        const filter = {
            selectedPeriod: newPeriod,
            startDate: clampedStart,
            endDate: newEnd,
            selectedSpace: selectedSpace2
        };
        localStorage.setItem(`${tenant}-util-filter`, JSON.stringify(filter));

        setSelectedPeriod(newPeriod);
        setStartDate(clampedStart);
        setEndDate(newEnd);
        setFilters(filter);
    };
    
    const handleEndDateChange = async (value) => {
        const now = moment().format();
    
        // If new end is before current start, pull start back to match end
        if (moment(value).isBefore(moment(startDate))) {
            setStartDate(value);
        }
    
        // If new end is in the future, clamp it to now
        const clampedEnd = moment(value).isAfter(moment(now)) ? now : value;
        setEndDate(clampedEnd);
    
        setSelectedPeriod('Custom');
    };

    const handlePeriodChange = async (value) => {
        if (value !== 'Custom') {
            let start, end;
            switch (value) {
                case 'Last 24 hours':
                    start = moment().subtract(24, 'hours').format();
                    end = moment().format();
                    break;
                case 'Today':
                    start = moment().startOf('day').format();
                    end = moment().format();
                    break;
                case 'Last 5 min':
                    start = moment().subtract(5, 'minutes').format();
                    end = moment().format();
                    break;
                case 'Last 20 min':
                    start = moment().subtract(20, 'minutes').format();
                    end = moment().format();
                    break;
                case 'Last 1 hour':
                    start = moment().subtract(1, 'hour').format();
                    end = moment().format();
                    break;
                case 'Last 4 hours':
                    start = moment().subtract(4, 'hours').format();
                    end = moment().format();
                    break;
                case 'Last 12 hours':
                    start = moment().subtract(12, 'hours').format();
                    end = moment().format();
                    break;
                case 'Yesterday':
                    start = moment().subtract(1, 'day').startOf('day').format();
                    end = moment().subtract(1, 'day').endOf('day').format();
                    break;
                case 'This Week':
                    start = moment().startOf('week').format();
                    end = moment().format();
                    break;
                case 'Last Week':
                    start = moment().subtract(1, 'weeks').startOf('week').format();
                    end = moment().subtract(1, 'weeks').endOf('week').format();
                    break;
                case 'This Month':
                    start = moment().startOf('month').format();
                    end = moment().format();
                    break;
                case 'Last Month':
                    start = moment().subtract(1, 'month').startOf('month').format();
                    end = moment().subtract(1, 'month').endOf('month').format();
                    break;
                case 'Last 7 days':
                    start = moment().subtract(7, 'days').format();
                    end = moment().format();
                    break;
                default:
                    break;
            }
            setStartDate(start);
            setEndDate(end);
            setSelectedPeriod(value);
        }
    };

    function submitOk() {
        if (moment(endDate).isAfter(moment(startDate))) {
            console.log("selectedSpace2", selectedSpace2)
            console.log("endDate", endDate)
            let filter = {
                "selectedPeriod": selectedPeriod,
                "startDate": startDate,
                "endDate": endDate,
                "selectedSpace": selectedSpace2
            }
            localStorage.setItem(`${tenant}-util-filter`, JSON.stringify(filter));
            setFilters(filter)
        } else {
            console.log('add toast here! End date should be after Start date', "startDate, endDate", startDate, endDate);
        }
    }


    useEffect(() => {
        // 1. THE GUARD CLAUSE
        // This prevents the API call if any required value is missing
        console.log("ids2",ids)
        if (!startDate || !endDate || !ids || !selectedPeriod) {
            console.log("Waiting for all filters to have values...");
            return;
        }
        const getSpaces = () => {
            const from = startDate;
            const to = endDate;
            // 2. LOGIC VALIDATION
            if (from < to) {
                // @@@ add spinner here (e.g., setIsLoading(true))
                AssetsService.getFloorplanIds(ids, from, to)
                    .then((value) => {
                        let currentSpaces = value.data.data
                        if (currentSpaces.length > 0) {
                            setSpaces(currentSpaces);
                            console.log("currentSpaces[0].id", currentSpaces[0].id)
                            console.log("filters", filters)
                            if (!currentSpaces.some(space => space.id === filters.selectedSpace)) {
                                console.log("!currentSpaces.some(space => space.id ===filters.selectedSpace)", !currentSpaces.some(space => space.id === filters.selectedSpace))
                                console.log("filters.selectedSpace", filters.selectedSpace)
                                console.log("currentSpaces", currentSpaces)
                                setSelectedSpace2(currentSpaces[0].id);
                            }
                            // setSelectedSpace2(currentSpaces[0].id);
                        }

                    })
                    .finally(() => {
                        // @@@ remove spinner here
                    });
            } else {
                // Use your Toast logic here
                console.error('Validation Error: End date must be after start date');
            }
        };
        getSpaces();
        // 3. DEPENDENCY ARRAY
        // Added selectedPeriod here so it re-fires if the user changes the timeframe
    }, [startDate, endDate, ids, selectedPeriod]);

    function onFloorplanValueChanged(e) {
        if (e.value === "6a21bf9e-fc6b-4bec-9f5c-8f8297772091") {
            setFloorplanGeo(true)
        } else {
            setFloorplanGeo(false)
        }
        setSelectedSpace2(e.value)
        // getData(e.value)
    }

    function onAutoUpdateValueChange(e) {
        if (e.value) {
            let filter = {
                "selectedPeriod": selectedPeriod,
                "startDate": startDate,
                "endDate": moment().format(),
                "selectedSpace": selectedSpace2
            }
            localStorage.setItem(`${tenant}-util-filter`, JSON.stringify(filter));
            setFilters(filter)
            setCheckAutoUpdate(!checkAutoUpdate)

        }
    }



    useEffect(() => {
        const startAutoUpdate = () => {
            intervalRef.current = setInterval(() => {
                setEndDate(moment().format())
            }, WAIT_TIME);
        };
        const stopAutoUpdate = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
        if (checkAutoUpdate) {
            stopAutoUpdate(); // Clear any previous intervals to avoid duplicates
            startAutoUpdate();
        } else {
            stopAutoUpdate();
        }
        // Cleanup on unmount
        return () => stopAutoUpdate();
    }, [checkAutoUpdate, selectedSpace2]);

    useEffect(() => {
        submitOk()
    }, [endDate, selectedSpace2]);


    useEffect(() => {
        if (selectedPeriod !== "Custom") {
            setCheckAutoUpdate(false)
        }
        submitOk()
    }, [selectedPeriod]);

    useEffect(() => {
        setCheckAutoUpdate(false)
        submitOk()
    }, [startDate]);

    useEffect(() => {
        console.log("names", names)
    }, [names]);


    return (
        <>
            <div className='topBarAssetTab'>
                <div className='titleAsset' >
                    {/* <b>Asset: {names.join(', ')}</b> &nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Last Position Update: {lastPositionUpdateTime}</span>&nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}>Dwell time in current space: {latestDwellTime}</span> */}
                    <b>Asset: {names.join(', ')}</b> &nbsp;&nbsp;<span style={{ paddingLeft: "12px", fontSize: "14px" }}></span>
                </div>
                <div className='backBtn' onClick={onSave}>
                    <i className="dx-icon-close"></i>
                </div>
            </div>
            <div className="btnContainerDateTime">
                <div className="dateBtn">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SelectBox
                            style={{ marginRight: '10px', width: '20%' }}
                            dataSource={[
                                'Today',
                                'Last 5 min',
                                'Last 20 min',
                                'Last 1 hour',
                                'Last 4 hours',
                                'Last 12 hours',
                                'Last 24 hours',
                                'Yesterday',
                                'This Week',
                                'Last Week',
                                'This Month',
                                'Last Month',
                                'Last 7 days',
                                'Custom',
                            ]}
                            value={selectedPeriod}
                            onValueChanged={(e) => handlePeriodChange(e.value)}
                            labelMode="static"
                            label="Period"
                            stylingMode="outlined"
                        />
                        <DateBox
                            style={{ marginRight: '10px' }}
                            type="datetime"
                            value={startDate}
                            onValueChanged={async (e) => await handleStartDateChange(e.value)}
                            placeholder="Start Date"
                            labelMode="static"
                            label="Start Date"
                            stylingMode="outlined"
                            displayFormat="yyyy-MM-dd HH:mm"
                            valueFormat="yyyy-MM-dd HH:mm"
                        />
                        <DateBox
                            style={{ marginRight: '10px' }}
                            type="datetime"
                            value={endDate}
                            onValueChanged={async (e) => await handleEndDateChange(e.value)}
                            placeholder="End Date"
                            labelMode="static"
                            label="End Date"
                            stylingMode="outlined"
                            displayFormat="yyyy-MM-dd HH:mm"
                            valueFormat="yyyy-MM-dd HH:mm"
                        />
                        <SelectBox
                            style={{ marginRight: '10px' }}
                            labelMode="static"
                            label="Floorplan"
                            items={spaces}
                            stylingMode="outlined"
                            value={selectedSpace2}
                            onValueChanged={onFloorplanValueChanged}
                            valueExpr="id"
                            displayExpr="name"
                        ></SelectBox>
                        {/* <div className="ok-btn" onClick={submitOk}>
                            OK
                        </div> */}
                        <div className='assetTab-autoUpdate'>
                            <CheckBox
                                value={checkAutoUpdate}
                                text="Auto Update"
                                // disabled={isDisableAutoUpdate}
                                stylingMode="outlined"
                                labelMode="static"
                                onValueChanged={onAutoUpdateValueChange}
                                style={{ cursor: "pointer" }}
                                focusStateEnabled={false}
                                className='check-auto-update'
                                visible={selectedTabIndex !== 3 && selectedTabIndex !== 4}
                            >
                            </CheckBox>
                        </div>

                        {selectedTabIndex === 0 && (
                            <div className="assettab-uploadBtnMechanicalReport">
                                <button
                                    id="generatePdfButton"
                                    alt="Export Data"
                                    title="Export Data"
                                    type="button"
                                    onClick={() => assetMultipleRef.current?.exportGrid()}
                                >
                                    <img
                                        src="../icons/excelNew.svg"
                                        alt="Export Data"
                                        style={{ height: '24px', width: '24px' }}
                                    />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <TabPanel ref={tabPanelRef}
                swipeEnabled={false}
                selectedIndex={selectedTabIndex}
                onOptionChanged={(e) => {
                    // setCheckAutoUpdate(false)
                    if (e.name === "selectedIndex") {
                        setSelectedTabIndex(e.value);
                        setCheckAutoUpdate(false)

                    }
                }}>
                {console.log("filters.selectedSpace", filters.selectedSpace)}

                {console.log("ids@@",ids)}
                <Item title="History" >
                    <AssetViewMultiple
                        ref={assetMultipleRef}
                        assetIds={ids}
                        assetColorMap={assetColorMap}
                        assetName={pageName}
                        startDate={filters.startDate}
                        endDate={filters.endDate}
                        selectedTabIndex={selectedTabIndex}
                        selectedSpace={filters.selectedSpace}
                        floorplanGeo={floorplanGeo}
                        isPoll={checkAutoUpdate}
                        spaces={spaces.map(space => space.id)}
                    />
                </Item>
                <Item title="Edit" visible={ids.length === 1}>
                    <div className="chart-row-three">
                        <EditTab
                            assetId={ids[0]}
                        />
                    </div>
                </Item>
                <Item title="Actions" visible={ids.length === 1 && (features.checkInOut.isfeature || features.retrieval.isfeature)}>
                    <div className="chart-row-three">
                        <ActionsTab
                            assetId={ids[0]}
                            features={features}
                        />
                    </div>
                </Item>
                <Item title="Utilization" visible={features.utilization.isfeature}>
                    <UtilizationHeatMap
                        assetIds={ids}
                        assetColorMap={assetColorMap}
                        assetName={pageName}
                        spaces={spaces}
                        tenant={tenant}
                        startDate={filters.startDate}
                        endDate={filters.endDate}
                        // dateRange={dateRange}
                        // onDateChange={(dateRange) => setDateRange(dateRange)}
                        isActive={selectedTabIndex === 3}
                        features={features}
                    // assetType={assetType}
                    />
                </Item>
                <Item title="Telemetry" visible={features.temperatureTelemetry.isfeature || features.cycleTelemetry.isfeature || features.impactTelemetry.isfeature}>
                    <div className="chart-row-three-telemetry">
                        <CyclesChart
                            assetIds={ids}
                            assetColorMap={assetColorMap}
                            startDate={filters.startDate}
                            endDate={filters.endDate}
                            features={features}
                        />
                    </div>
                </Item>
            </TabPanel>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
            <LoadingPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                showPane={true}
                shading={true}
                closeOnOutsideClick={false}
            />
        </>
    );
}